import React, { useState } from "react";
import Courses from "../Courses/Courses";
import "./CoursesPage.css";
import { Helmet } from "react-helmet-async";

const CoursesPage = () => {

    const [coursesOpenFAQ, setCoursesOpenFAQ] = useState(null);

    const coursesFAQs = [
        {
            question: "What IT courses does PRT Academy offer?",
            answer:
                "PRT Academy offers industry-focused IT courses designed to help students and freshers build practical software development skills. Courses include Java Full Stack, Python Full Stack, MERN Stack, Data Structures & Algorithms (DSA), and Generative AI, subject to current program availability."
        },
        {
            question: "Which course is best for starting an IT career?",
            answer:
                "The right course depends on your educational background, programming knowledge, career goal, and preferred technology. PRT Academy offers multiple learning paths, including Java Full Stack, Python Full Stack, MERN Stack, DSA, and Generative AI, to help learners choose a suitable career direction."
        },
        {
            question: "Are PRT Academy courses suitable for freshers?",
            answer:
                "Yes. PRT Academy courses are designed to help students and freshers develop programming knowledge, practical development skills, project experience, and interview readiness. Course prerequisites may vary depending on the selected program."
        },
        {
            question: "Do PRT Academy courses include practical training?",
            answer:
                "Yes. PRT Academy focuses on practical, industry-oriented learning. Depending on the course, students can work on coding exercises, assignments, practical sessions, and projects to apply concepts learned during training."
        },
        {
            question: "Does PRT Academy provide internship opportunities?",
            answer:
                "Yes. PRT Academy provides internship opportunities as part of its career-focused approach, subject to the applicable program and eligibility requirements. Internships can help students gain practical experience and strengthen their project portfolios."
        },
        {
            question: "Does PRT Academy provide placement assistance?",
            answer:
                "Yes. PRT Academy provides placement assistance to eligible students through career guidance, resume support, interview preparation, mock interviews, and relevant job opportunities, subject to the applicable placement terms and conditions."
        },
        {
            question: "Does PRT Academy offer job assistance with a fee-refund policy?",
            answer:
                "PRT Academy offers a job-assistance commitment for eligible students subject to its applicable terms and conditions. Students who fulfill all required conditions but do not secure a job may be eligible for a 50% refund of the paid course fee, according to the official placement and refund policy."
        },
        {
            question: "What is the duration of PRT Academy courses?",
            answer:
                "Course duration varies depending on the selected program, curriculum, training requirements, and learning format. Students should check the individual course page or contact PRT Academy for the current duration of their preferred course."
        },
        {
            question: "Does PRT Academy provide career guidance?",
            answer:
                "Yes. PRT Academy provides career guidance to help students understand suitable technology career paths, improve their technical skills, prepare for interviews, and become more job-ready."
        },
        {
            question: "Can students learn Data Structures & Algorithms at PRT Academy?",
            answer:
                "Yes. PRT Academy offers Data Structures & Algorithms (DSA) training to help students develop problem-solving and coding skills that are useful for technical interviews and software development careers."
        },
        {
            question: "Are PRT Academy courses available in Hyderabad?",
            answer:
                "Yes. PRT Academy is based in Hyderabad and provides IT-focused training for students, freshers, and aspiring technology professionals. Contact the academy for current classroom schedules and course availability."
        },
        {
            question: "How can I enroll in a PRT Academy course?",
            answer:
                "You can contact PRT Academy through the website to enquire about your preferred course. The academy team can provide information about the current curriculum, duration, eligibility, fees, schedule, learning format, and enrollment process."
        }
    ];

    const toggleCoursesFAQ = (index) => {
        setCoursesOpenFAQ(
            coursesOpenFAQ === index ? null : index
        );
    };

    return (
        <>
            <Helmet>

                <title>
                    IT Courses in Hyderabad | PRT Academy
                </title>

                <meta
                    name="description"
                    content="Explore IT courses in Hyderabad at PRT Academy, including Java, Python, Full Stack, MERN, DSA, DevOps and Generative AI training with practical learning and placement assistance."
                />

                <meta
                    name="keywords"
                    content="IT Courses in Hyderabad, IT Training Courses in Hyderabad, Software Courses in Hyderabad, IT Courses for Freshers in Hyderabad, Job Oriented IT Courses in Hyderabad, Full Stack Development Courses in Hyderabad, Java Full Stack Course in Hyderabad, Python Full Stack Course in Hyderabad, MERN Stack Course in Hyderabad, DSA Course in Hyderabad"
                />

            </Helmet>


            {/* ==============================
                COURSES HEADER
            =============================== */}

            <section className="courses-page-header">

                <div className="page-badge">
                    PRT Academy Courses
                </div>

                <h1>
                    Choose Your <span>Learning Path</span>
                </h1>

                <p>
                    Build practical full stack development skills through
                    structured learning and real-time projects.
                </p>

            </section>


            {/* ==============================
                COURSES
            =============================== */}

            <Courses />


            {/* ==============================
                COURSES FAQ
            =============================== */}

            <section className="courses-faq-section">

                <div className="courses-faq-badge">
                    Courses FAQ
                </div>

                <h2 className="courses-faq-title">
                    Frequently Asked <span>Questions</span>
                </h2>

                <p className="courses-faq-intro">
                    Find answers to common questions about PRT Academy
                    courses, training, internships, placements and enrollment.
                </p>


                <div className="courses-faq-list">

                    {coursesFAQs.map((faq, index) => (

                        <div
                            className={`courses-faq-card ${
                                coursesOpenFAQ === index
                                    ? "courses-faq-active"
                                    : ""
                            }`}
                            key={index}
                        >

                            <button
                                type="button"
                                className="courses-faq-question"
                                onClick={() =>
                                    toggleCoursesFAQ(index)
                                }
                            >

                                <span>
                                    {faq.question}
                                </span>

                                <span className="courses-faq-icon">
                                    {coursesOpenFAQ === index
                                        ? "−"
                                        : "+"}
                                </span>

                            </button>


                            {coursesOpenFAQ === index && (

                                <div className="courses-faq-answer">

                                    <p>
                                        {faq.answer}
                                    </p>

                                </div>

                            )}

                        </div>

                    ))}

                </div>

            </section>

        </>
    );
};

export default CoursesPage;